<template>
  <v-app class="ext-l">
    <notify />
    <RefreshAppAlert />
    <!-- APPLICATION BAR  -->
    <v-app-bar
      style="box-shadow:0 0 20px rgba(0, 0, 0, 0.13)"
      id="home-app-bar"
      flat
      height="100px"
      app
      color="#F5F6F7"
      clipped-left
    >

      <v-btn v-if="needShowBurgerMenu" icon @click="drawer = !drawer">
        <v-icon>mdi mdi-menu</v-icon>
      </v-btn>

      <div class="align-center d-flex logo-container">
        <img v-bind:src="logoUrl" class="pl-3 full-logo" />
        <div class="company-title px-4 d-md-block">
          <p class="title" v-text="companyName"></p>
          <div class="text--secondary" v-text="slogan"></div>
        </div>
      </div>

      <div class="top-toolbar px-4">
        <dr-layout-placeholder :model="{$ID:'pl1', Name:'TopToolbar'}"></dr-layout-placeholder>
      </div>

      <div class="d-flex justify-end align-center right-side-items">
        <!-- right-side action items -->
        <v-badge overlap :content="3" :value="3" color="red" offset-x="15" offset-y="18">
          <v-btn icon>
            <v-icon color="orange" class="pa-2">mdi mdi-bell-ring</v-icon>
          </v-btn>
        </v-badge>
        <v-btn icon>
          <v-icon class="pa-2">mdi mdi-cog</v-icon>
        </v-btn>

        <!-- <lang-switcher /> -->
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-list dense style="background:transparent;" class="py-0 pl-3">
              <v-list-item v-on="on" two-line :class="'px-0'">
                <v-list-item-content style="flex-direction:column; align-items:start">
                  <v-list-item-title>{{$store.state.auth.user.authData.userName}}</v-list-item-title>
                  <v-list-item-subtitle>{{$store.state.auth.user.authData.login}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title @click="$authCore.SignOut()">{{$t('login.signOut')}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

    </v-app-bar>

    <!-- NAVIGATION -->

    <v-navigation-drawer elevation="1" clipped app v-model="drawer" width="300">
      <!-- <div @click="minidrawer = !minidrawer" class="drawer-toggler">
      <v-icon>mdi mdi-chevron-double-left</v-icon>
      </div>-->
      <div class="logo" v-if="needShowBurgerMenu">
        <img v-bind:src="logoUrl" class="pl-3 full-logo" />
      </div>
      <NavigationMenu :class='!needShowBurgerMenu ? "navigation-content-items" : ""' :items="sidebarItems" />
    </v-navigation-drawer>

    <!-- CONTENT -->
    <v-content style="background:#f1f4f6">
      <v-progress-linear v-if="loader" indeterminate height="5" color="primary" absolute></v-progress-linear>
      <v-container>
        <v-row>
          <v-col cols="8" lg="9" class="pa-0">
            <dr-layout-placeholder :model="{$ID:'pl3'+ this.routeName, Name:'Main'}"></dr-layout-placeholder>
          </v-col>
          <v-col cols="4" lg="3" class="pa-0 pl-5">
            <dr-layout-placeholder :model="{$ID:'pl3'+ this.routeName, Name:'rightSideBar'}"></dr-layout-placeholder>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  
  </v-app>
</template>

<script>
import Notify from '@/components/Notify'
import inputMixin from '@it-enterprise/web-app-common/src/mixins/input-mixin'
import layoutMixin from '@it-enterprise/web-app-common/src/mixins/layout-mixin'
import RefreshAppAlert from '@/components/RefreshAppAlert'
import store from '../store'

export default {
  name: 'ExtendedLayout',
  mixins: [inputMixin, layoutMixin],
  components: {
    Notify,
    RefreshAppAlert
  },
  data: () => ({
    drawer: true,
    minidrawer: true,
    items: [
      { title: 'Dashboard', icon: 'mdi-view-dashboard' },
      { title: 'Photos', icon: 'mdi-image' },
      { title: 'About', icon: 'mdi-help-box' }
    ],
    needDefaultImage: false,
    glFirmLogoImg: process.env.VUE_APP_BASE_PATH + 'src/assets/energo/logo.png',
    slogan: store.state.general.config.Slogan
  }),
  computed: {
    routeName() {
      return this.$route.name
    },
    sidebarItems() {
      return this.$store.getters.AppNavigation
    },
    isUserAuthenticated() {
      return this.$authCore.isAuthenticated
    },
    loader() {
      return this.$store.getters.getProcessing
    },
    needShowBurgerMenu() {
      if (
        this.$vuetify.breakpoint.name == 'xl' ||
        this.$vuetify.breakpoint.name == 'lg'
      ) {
        this.setModeDrawer(true)
        return false
      }
      this.setModeDrawer(false)
      return true
    }
  },
  methods: {
    setModeDrawer(value) {
      this.minidrawer = value
    },
    load() {
      this.needDefaultImage = false
    },
    error() {
      this.needDefaultImage = true
    }
  }
}
</script>

<style lang="scss" >
.ext-l {
  .company-title {
    max-height: 100%;
    overflow: hidden;
  }

  .v-navigation-drawer__border {
    display: none;
  }

  nav.v-navigation-drawer {
    // box-shadow: 0 0px 18px 0px rgba(0, 0, 0, 0.06);
    background-color: transparent;
  }
  nav.v-navigation-drawer--is-mobile {
    background-color: #fff;
  }
  .small-logo {
    display: none;
  }
  .logo {
    height: 75px;
    // background: #fafbfc;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .v-navigation-drawer--mini-variant {
    .full-logo {
      display: none;
    }
    .small-logo {
      display: block;
    }
  }

  .drawer-toggler {
    // $border: 1px solid #e2e5e7;
    display: flex;
    position: absolute;
    width: 20px;
    height: 20px;
    right: 0;
    top: 25px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    // border-left: $border;
    // border-top: $border;
    // border-bottom: $border;
    cursor: pointer;
    z-index: 1000;
    i {
      display: block;
      font-size: 20px;
    }
  }

  .full-logo {
    padding-left: 0px !important;
    width: 150px;
  }

  .navigation-content-items {
    margin-top: 20px;
  }

  .right-side-items {
    margin: 0 0 0 auto;
  }
}
</style>